import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [subError, setSubError] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpField = formData.get('phone_alt');
    if (hpField && String(hpField).trim() !== '') {
      setSubStatus('success');
      setEmail('');
      return;
    }

    setSubStatus('submitting');
    setSubError('');

    try {
      const res = await fetch('http://metcw.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== 'phone_alt')
            .map(([k, v]) => [k, String(v)])
        ).toString(),
      });

      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* not json */ }

      if (res.ok && (parsed as { code?: string }).code === 'OK') {
        setSubStatus('success');
        setEmail('');
      } else {
        const serverMsg: string =
          (parsed as { meta?: { message?: string } }).meta?.message ||
          (parsed as { message?: string }).message ||
          text ||
          '订阅失败，请稍后重试';
        setSubError(serverMsg.toLowerCase().includes('spam') ? '订阅失败，请稍后重试' : serverMsg);
        setSubStatus('error');
      }
    } catch {
      setSubError('网络错误，请检查连接后重试');
      setSubStatus('error');
    }
  };

  const column1 = [
    { label: '热血战斗', to: '/category/rexue' },
    { label: '恋爱甜宠', to: '/category/lianai' },
    { label: '悬疑惊悚', to: '/category/xuanyi' },
    { label: '奇幻冒险', to: '/category/qihuan' },
  ];

  const column2 = [
    { label: '常见问题', to: '/about#faq' },
    { label: '阅读指南', to: '/about' },
    { label: '更新日志', to: '/about' },
    { label: '用户反馈', to: '/about' },
  ];

  const column3 = [
    { label: '品牌故事', to: '/about' },
    { label: '版权声明', to: '/about' },
    { label: '加入我们', to: '/about' },
    { label: '商务合作', to: '/about' },
  ];

  const column4 = [
    { label: '客服邮箱', to: '/about' },
    { label: '官方微博', to: '/about' },
    { label: '微信公众号', to: '/about' },
    { label: '官方QQ群', to: '/about' },
  ];

  return (
    <footer className="relative bg-[#0a1f1c] overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
        <div className="w-full h-full bg-[radial-gradient(circle_at_30%_50%,oklch(0.7_0.15_80/0.1),transparent_50%),radial-gradient(circle_at_70%_30%,oklch(0.7_0.15_80/0.05),transparent_50%)]"></div>
      </div>

      <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[320px] flex-shrink-0">
            <Link to="/" className="inline-flex items-center gap-2 mb-6">
              <span className="font-heading text-xl md:text-2xl font-bold text-white tracking-wider">
                虚空韩漫网
              </span>
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            </Link>

            <form
             
              onSubmit={handleSubscribe}
              className="mb-6"
            >
              <div className="flex items-stretch gap-0">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱，订阅更新"
                  required
                  className="flex-1 px-4 py-3 text-sm bg-transparent border border-foreground-700/30 rounded-l-lg text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                />
                <button
                  type="submit"
                  disabled={subStatus === 'submitting'}
                  className="px-4 py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-white rounded-r-lg transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-mail-send-line text-lg"></i>
                </button>
              </div>

              <div className="hp-field-wrap">
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>

              {subStatus === 'success' && (
                <p className="mt-2 text-xs text-green-400">订阅成功！感谢关注。</p>
              )}
              {subStatus === 'error' && subError && (
                <p className="mt-2 text-xs text-red-400">{subError}</p>
              )}
            </form>

            <p className="font-heading text-xl md:text-2xl text-white/80 leading-relaxed">
              随时随地
              <br />
              畅读韩漫
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <h4 className="text-white font-medium text-sm mb-5">热门分类</h4>
              <ul className="flex flex-col gap-3">
                {column1.map((item) => (
                  <li key={item.label}>
                    <Link to={item.to} className="text-foreground-500 hover:text-foreground-200 text-sm transition-colors duration-200 whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-white font-medium text-sm mb-5">帮助中心</h4>
              <ul className="flex flex-col gap-3">
                {column2.map((item) => (
                  <li key={item.label}>
                    <Link to={item.to} className="text-foreground-500 hover:text-foreground-200 text-sm transition-colors duration-200 whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-white font-medium text-sm mb-5">关于我们</h4>
              <ul className="flex flex-col gap-3">
                {column3.map((item) => (
                  <li key={item.label}>
                    <Link to={item.to} className="text-foreground-500 hover:text-foreground-200 text-sm transition-colors duration-200 whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-white font-medium text-sm mb-5">联系方式</h4>
              <ul className="flex flex-col gap-3">
                {column4.map((item) => (
                  <li key={item.label}>
                    <Link to={item.to} className="text-foreground-500 hover:text-foreground-200 text-sm transition-colors duration-200 whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-foreground-700/20 flex flex-col sm:flex-row items-center justify-between gap-6">
          <p className="text-foreground-600 text-xs">
            &copy; 2020-2026 虚空韩漫网 xukongmanhua.com 版权所有
          </p>

          <div className="flex items-center gap-3">
            {['ri-weibo-line', 'ri-wechat-line', 'ri-qq-line', 'ri-bilibili-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-700/30 text-foreground-500 hover:text-foreground-200 hover:border-foreground-500/50 transition-colors duration-200 cursor-pointer"
                rel="nofollow"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>

          <a href="#" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors duration-200 whitespace-nowrap">
            隐私政策
          </a>
        </div>
      </div>
    </footer>
  );
}